"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function schemaPath(obj, typeonly) {
    var key = obj.$key;
    if (obj.$parent) {
        var res = schemaPath(obj.$parent, typeonly);
        if (typeonly && ((obj.type === undefined) || (obj.type === 'object') && (obj.$parent) && (obj.$parent.type === 'array'))) {
            return res;
        }
        else {
            if (typeonly && obj.type === 'array') {
                key += '[]';
            }
        }
        if (res === '') {
            return key;
        }
        else {
            return res + '.' + key;
        }
    }
    else {
        if (typeonly && obj.type === undefined) {
            return '';
        }
        if (key) {
            return key;
        }
        else {
            return '';
        }
    }
}
exports.default = schemaPath;
//# sourceMappingURL=schemaPath.js.map